<div class="field-link fx-layout-row fx-justify-start fx-align-baseline fx-gap-5">
  <span class="mdi mdi-plus-box-outline"></span>
  <span class="message" tabindex="0">{{ inputMessage }}</span>
</div>
